import { faTimesCircle } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Link, Box, Button, Typography } from '@mui/material'
import React, { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router'

import routes from 'routes'

const sx = {
  root: {
    position: 'fixed',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    display: 'flex',
  },
  body: {
    margin: 'auto',
  },
}

const ErrorMessage = ({ error, onCloseClick }) => {
  const message = getMessage(error)
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const onCloseClickInternal = useCallback(() => {
    dispatch({ type: 'clearError' })
    navigate(routes.home)

    if (onCloseClick) {
      onCloseClick()
    }
  }, [dispatch, navigate, onCloseClick])

  if (process.env['REACT_APP_ENV'] !== 'prod') {
    console.log(error.message)
    console.log(error.stack)
  }

  return (
    <Box sx={sx.root}>
      <Box sx={sx.body}>
        <Box display="flex" flexDirection="column" alignItems="center">
          <FontAwesomeIcon icon={faTimesCircle} size="5x" color="#FF5A5F" />
          <Box pb={3} />
          <Typography>Sorry, something went wrong, please try again later</Typography>
          <Typography>
            <span>Still have questions? </span>
            <Link href={`mailto:${process.env.REACT_APP_SUPPORT_EMAIL}`}>Get help</Link>
          </Typography>

          <Box my={5}>
            <Button variant="outlined" onClick={onCloseClickInternal}>
              Close
            </Button>
          </Box>

          <Box mt={2} maxWidth={420}>
            <Typography style={{ wordBreak: 'break-word' }}>{message}</Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

const getMessage = error => {
  const isDevEnv = process.env['REACT_APP_ENV'] !== 'prod'
  return isDevEnv ? error.message : 'Error'
}

export default ErrorMessage
